import {
  decorate,
  observable,
  action,
  runInAction,
} from 'mobx'

import AsyncStoreBase from '~src/store/AsyncStoreBase'
import Api from './example.api'

class ExampleStore extends AsyncStoreBase {
  constructor () {
    super()

    runInAction(() => {
      this.collection = []
    })
  }

  sendThings = async (things) => {
    try {
      this.setBusy(true)
      this.setError()
      const { status } = await Api.sendThings(things)
      this.getThings()
      this.setSuccess(!!status && status === 200)

      this.setBusy(false)
    } catch (err) {
      this.setError(err)
      this.setBusy(false)
    }
  }

  getThings = async (filter) => {
    try {
      this.setBusy(true)
      this.setError()
      const { data, status } = await Api.getThings(filter)
      this.setSuccess(!!status && status === 200)

      runInAction(() => {
        this.collection = data
      })
      this.setBusy(false)
    } catch (err) {
      this.setError(err)
      this.setBusy(false)
    }
  }
}

decorate(ExampleStore, {
  collection: observable,
  getThings: action
})

export default new ExampleStore()
